import { schema } from 'normalizr';
import { createAction } from 'redux-api-middleware';
import { handleResponse, handleError } from '../utils';

export const FETCH_ROLES_REQUEST = 'FETCH_ROLES_REQUEST';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE';
export const FETCH_ROLE_REQUEST = 'FETCH_ROLE_REQUEST';
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_ROLE_FAILURE = 'FETCH_ROLE_FAILURE';
export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAILURE = 'CREATE_ROLE_FAILURE';
export const EDIT_ROLE_REQUEST = 'EDIT_ROLE_REQUEST';
export const EDIT_ROLE_SUCCESS = 'EDIT_ROLE_SUCCESS';
export const EDIT_ROLE_FAILURE = 'EDIT_ROLE_FAILURE';
export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE';

export const rolesSchema = new schema.Entity('roles', {}, { idAttribute: 'slug' });

/**
 * Fetch All roles
 *
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchAllRoles = () => {
  return createAction({
    endpoint: `${window.config.apiUrl}/roles`,
    method: 'GET',
    types: [
      { type: FETCH_ROLES_REQUEST },
      {
        type: FETCH_ROLES_SUCCESS,
        payload: (action, state, res) => handleResponse([rolesSchema], action, state, res),
      },
      { type: FETCH_ROLES_FAILURE, payload: handleError },
    ],
  });
};

/**
 * Fetch role details
 *
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchRoleDetails = slug => {
  return createAction({
    endpoint: `${window.config.apiUrl}/roles/${slug}`,
    method: 'GET',
    types: [
      { type: FETCH_ROLE_REQUEST },
      {
        type: FETCH_ROLE_SUCCESS,
        payload: (action, state, res) => handleResponse([rolesSchema], action, state, res),
      },
      { type: FETCH_ROLE_FAILURE, payload: handleError },
    ],
  });
};

/**
 * Returns a redux api middleware action that makes a request to create a role.
 *
 * @param {object} values - New role field values.
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const createRole = values =>
  createAction({
    endpoint: `${window.config.apiUrl}/roles`,
    method: 'POST',
    body: JSON.stringify(values),
    types: [
      { type: CREATE_ROLE_REQUEST },
      {
        type: CREATE_ROLE_SUCCESS,
        payload: (action, state, res) => handleResponse(rolesSchema, action, state, res),
      },
      { type: CREATE_ROLE_FAILURE, payload: handleError },
    ],
  });

/**
 * Returns a redux api middleware action that makes a request to edit a Role.
 *
 * @param {object} values - New Role field values.
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const editRole = values =>
  createAction({
    endpoint: `${window.config.apiUrl}/roles`,
    method: 'PUT',
    body: JSON.stringify(values),
    types: [
      { type: EDIT_ROLE_REQUEST },
      {
        type: EDIT_ROLE_SUCCESS,
        payload: (action, state, res) => handleResponse(rolesSchema, action, state, res),
      },
      { type: EDIT_ROLE_FAILURE, payload: handleError },
    ],
  });

/**
 * Returns a redux api middleware action that deletes a role.
 *
 * @param {object} slug - slug value for a Role.
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const deleteRole = slug =>
  createAction({
    endpoint: `${window.config.apiUrl}/roles/${slug}`,
    method: 'DELETE',
    body: JSON.stringify({ slug }),
    types: [
      { type: DELETE_ROLE_REQUEST },
      { type: DELETE_ROLE_SUCCESS },
      { type: DELETE_ROLE_FAILURE, payload: handleError },
    ],
  });
